var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputTag',{class:`tags-input ${_vm.removeOnly ? 'remove-only' : ''}`,attrs:{"value":_vm.valueAsArray,"placeholder":_vm.removeOnly ? '' : _vm.placeholder,"read-only":_vm.readOnly},on:{"input":_vm.handleChange,"hook:updated":_vm.removeDefaultClassName}})
}
var staticRenderFns = []

export { render, staticRenderFns }